// extracted by mini-css-extract-plugin
module.exports = {"Home":"Home_Home__2Ts0o"};